import pageHeader from "@/modules/layout/page-header/helperHeader";
import generateId from "@/scripts/helpers/generateId";
import attrs from "attrs";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

const mobileMenuDropDown = () => {
  const itemDropDown = document.querySelectorAll(".main-menu-toggler");
  const submenu = ".mobile-menu__submenu";

  itemDropDown.forEach(elem => {
    elem.addEventListener("click", event => {
      removeDropDownClass(elem);
      elem.classList.toggle("has-dropdown");
      elem.querySelectorAll(".mobile-menu__submenu")[0].style.display = "block";
      if (!elem.classList.contains("has-dropdown")) {
        elem.querySelectorAll(".mobile-menu__submenu")[0].style.display =
          "none";
      }
    });
  });
  const removeDropDownClass = item => {
    itemDropDown.forEach(elem => {
      if (item !== elem) {
        elem.classList.remove("has-dropdown");
        elem.querySelectorAll(".mobile-menu__submenu")[0].style.display =
          "none";
      }
    });
  };

  const dropdownInsideSubMenu = () => {
    const dropDownExpLink = document.querySelectorAll(".mobile-menu__submenu--dropdown .mobile-menu__submenu-link--bold");

    for (let i = 0; i < dropDownExpLink.length; i++) {
      const self = dropDownExpLink[i];

      self.addEventListener("click", function(e) {
        e.preventDefault();

        this.nextElementSibling.classList.toggle("is-active");
        this.closest(".mobile-menu__submenu--dropdown").classList.toggle("is-active");
      },);
    }
  };

  dropdownInsideSubMenu();
};

const dropDownSubmenu = () => {
  const submenuLink = document.querySelectorAll(".mobile-menu__submenu-link");
  const backButton = document.querySelector(
    ".js-mobile-nav-submenu__header-label"
  );
  const mobileMenu = document.querySelector(".mobile-menu__menu");
  const showNavSubmenu = "is-nav-submenu-active";
  const isActive = "is-active";

  submenuLink.forEach(elem => {
    elem.addEventListener("click", event => {
      event.stopPropagation();
      const menuType = event.target.getAttribute("data-navigate-to");
      if (menuType) {
        mobileMenu.classList.add(showNavSubmenu);
        document
          .querySelector(
            ".mobile-nav-submenu__body[data-menu=" + menuType + "]"
          )
          .classList.add(isActive);
      }
    });
  });

  if (backButton) {
    backButton.addEventListener("click", () => {
      mobileMenu.classList.remove(showNavSubmenu);
      document
        .querySelectorAll(".mobile-nav-submenu__body")
        .forEach(elem => elem.classList.remove(isActive));
    });
  }
};

const mobileHeaderPosition = () => {
  let count = 0;
  let lastScrollTop = 0;
  const desktopWidth = 960;
  const headerBar = document.querySelector(".page-header");

  if (window.innerWidth < desktopWidth && headerBar) {
    const offSet = headerBar.offsetHeight;
    headerBar.classList.add("is-active");
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      count++;
      if (scrollTop > lastScrollTop && offSet < lastScrollTop) {
        headerBar.classList.remove("is-active");
      } else if (count % 30 === 0 || offSet > scrollTop) {
        headerBar.classList.add("is-active");
      }
      lastScrollTop = scrollTop;
    });
  }
};

const headerSticky = () => {
  window.addEventListener("scroll", () => {
    const heightBody = document.documentElement.scrollTop;
    const headerShadow = document.querySelector(".js-header-shadow");
    const headerBar = document.querySelector(".page-header");
    const search = document.querySelector(".js-search-wrapper");
    const donateBanner = document.querySelector(".donate-ua-banner");

    if (headerShadow) {
      if (heightBody > 80) {
        headerShadow.classList.add("header-box-shadow");
        headerBar.classList.add("is-active");
        if (search) {
          search.classList.remove("is-visible");
          if (donateBanner) {
            donateBanner.classList.remove("donate-ua-banner--higher");
          }
        }
      } else {
        headerShadow.classList.remove("header-box-shadow");
      }
    }
  });
};

const desktopItemSubMenu = () => {
  const itemWithSubmenu = document.querySelectorAll(
    ".main-menu__item.has-dropdown"
  );
  const itemMenus = document.querySelectorAll(".main-menu__item");
  const headeMenuV1 = document.querySelectorAll(".main-menu");

  itemMenus.forEach(elem => {
    elem.addEventListener("focusin", event => {
      const currentItem = event.target.parentElement;
      if (
        currentItem.classList.contains("main-menu__item") &&
        !currentItem.classList.contains("main-menu__item.has-dropdown")
      ) {
        itemWithSubmenu.forEach(elem => {
          setTimeout(() => {
            if (elem.classList.contains("is-open"))
              elem.classList.remove("is-open");
          }, 10);
        });
      }
    });
  });

  itemWithSubmenu.forEach(elem => {
    if (headeMenuV1) {

      var menuEnterTimeout;
      var menuLeaveTimeout;

      elem.addEventListener("mouseenter", event => {
        const currentItem = event.target;

        clearTimeout(menuLeaveTimeout);

        menuEnterTimeout = setTimeout(function() {
          setTimeout(() => {
            if (!currentItem.classList.contains("is-open"))
              currentItem.classList.add("is-open");
            }, 10);
        }, 150);
      });

      elem.addEventListener("focusin", event => {
        const currentItem = event.target.parentElement;

        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("mouseleave", event => {
        const currentItem = event.target;

        clearTimeout(menuEnterTimeout);

        menuLeaveTimeout = setTimeout(function() {
          setTimeout(() => {
            if (currentItem.classList.contains("is-open"))
              currentItem.classList.remove("is-open");
          }, 10);
        }, 150);
      });

    } else {
      elem.addEventListener("mouseenter", event => {
        const currentItem = event.target;
        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("focusin", event => {
        const currentItem = event.target.parentElement;

        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("mouseleave", event => {
        const currentItem = event.target;

        setTimeout(() => {
          if (currentItem.classList.contains("is-open"))
            currentItem.classList.remove("is-open");
        }, 10);
      });
    };
  });
};

const Offcanvas = () => {
  anchorsAcademy();
  const toArray = nodeList => [].slice.call(nodeList);

  const options = {
    triggerSelector: "[data-offcanvas-trigger]",
    menuSelector: "[data-offcanvas-menu]",
    containerSelector: "[data-offcanvas-container]",
    overlaySelector: "[data-offcanvas-overlay]"
  };

  const triggers = toArray(document.querySelectorAll(options.triggerSelector));
  const container = document.querySelector(options.containerSelector);
  const overlay = document.querySelector(options.overlaySelector);
  const menu = document.querySelector(options.menuSelector);
  const body = document.querySelector("body");
  const mobileMenu = document.querySelector(".mobile-menu");

  const hide = () => {
    menu.setAttribute("aria-hidden", "true");
    container.setAttribute("data-offcanvas-hidden", "true");
    overlay.setAttribute("data-offcanvas-hidden", "true");
    triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "false");
    });
    enableBodyScroll(mobileMenu);
    clearAllBodyScrollLocks();
  };

  const show = () => {
    disableBodyScroll(mobileMenu);
    menu.setAttribute("aria-hidden", "false");
    container.setAttribute("data-offcanvas-hidden", "false");
    overlay.setAttribute("data-offcanvas-hidden", "false");
    triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "true");
    });
  };

  const isHidden = () => menu.getAttribute("aria-hidden") === "true";
  const toggle = () => (isHidden() ? show() : hide());
  const triggerClickHandler = () => toggle();

  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      triggerClickHandler();
    });
  });

  if (overlay) overlay.addEventListener("click", () => hide());

  const setA11yAttributes = () => {
    const id = generateId();
    container.setAttribute("data-offcanvas-hidden", "true");
    if (menu) {
      attrs(menu, {
        role: "dialog",
        tabindex: "-1",
        "aria-hidden": "true",
        id
      });
    }

    if (triggers && triggers.length > 0) {
      Array.prototype.forEach.call(triggers, trigger => {
        attrs(trigger, {
          role: "button",
          "aria-pressed": "false",
          "aria-expanded": "false"
        });
      });
    }
  };

  setA11yAttributes();
};

const anchorsAcademy = () => {
  const pageUrl = window.location.href.split("/");
  const lastSegment = pageUrl.pop() || pageUrl.pop();
  const menuLink = document.querySelectorAll(".mobile-menu__link");

  if (lastSegment === "academy" || lastSegment === "academy/") {
    menuLink.forEach(element => {
      element.setAttribute("data-offcanvas-trigger", "");
    });
  }
};

const headerLayout = document.querySelector(".layout__header");

if (headerLayout) {
  window.addEventListener("resize", () => {
    mobileHeaderPosition();
    headerSticky();
  });

  mobileMenuDropDown();
  dropDownSubmenu();
  mobileHeaderPosition();
  desktopItemSubMenu();
  headerSticky();
  Offcanvas();
  pageHeader();
}
